import axios from 'axios'

const REF_DATA_API = process.env.VUE_APP_REFDATA_API

function fetchSchools() {
  return axios.get(`${REF_DATA_API}/pc-schools.json`)
}

export default { fetchSchools }
